import { Component, Input, inject } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonIconComponent, FormGroupComponent, InputComponent, LinkComponent } from '@tecalisdev/infinity';

import { ReactiveFormsService } from '../../../../shared/services/reactive-forms.service';
import { WorkflowsHelperService } from '../../../services/workflows-helper.service';
import { createFormStepOptionGroup, assignFormStepOptionOrderValues } from '../form-step-options.helper';
import {
	formStepOptionLabelErrorMessage,
	formStepOptionLabelHasError,
	getFormStepOptionLabelControl,
} from '../form-step-option-locale-ui.util';

@Component({
	selector: 'app-form-step-options-editor',
	imports: [ReactiveFormsModule, TranslatePipe, FormGroupComponent, InputComponent, ButtonIconComponent, LinkComponent],
	templateUrl: './form-step-options-editor.component.html',
	styleUrl: './form-step-options-editor.component.scss',
})
export class FormStepOptionsEditorComponent {
	private workflowsHelper = inject(WorkflowsHelperService);
	private trans = inject(TranslateService);
	private reactiveFormService = inject(ReactiveFormsService);

	@Input({ required: true }) fieldGroup!: FormGroup;
	@Input() selectedLocaleId = 'es';

	public get optionsArray(): FormArray {
		return this.fieldGroup.get('options') as FormArray;
	}

	public getOptionLabelControl(optionIndex: number): FormControl {
		return getFormStepOptionLabelControl(this.optionsArray, optionIndex, this.selectedLocaleId);
	}

	public optionLabelHasError(optionIndex: number): boolean {
		return formStepOptionLabelHasError(
			this.reactiveFormService,
			this.optionsArray,
			optionIndex,
			this.selectedLocaleId,
			false,
		);
	}

	public optionLabelErrorMessage(optionIndex: number): string {
		return formStepOptionLabelErrorMessage(
			this.reactiveFormService,
			this.optionsArray,
			optionIndex,
			this.selectedLocaleId,
			false,
			this.trans.instant('ERRORS.REQUIRED'),
		);
	}

	public addOption(): void {
		this.optionsArray.push(createFormStepOptionGroup(this.workflowsHelper));
		assignFormStepOptionOrderValues(this.optionsArray);
	}

	public removeOption(optionIndex: number): void {
		if (this.optionsArray.length <= 1) {
			return;
		}

		this.optionsArray.removeAt(optionIndex);
		assignFormStepOptionOrderValues(this.optionsArray);
	}
}
